<template>
  <Modal
    class="tagsModal mfdmodel newModal"
    v-model="value"
    title="质量位详情"
    width="500px"
    :mask-closable="false"
    @on-cancel="closeDrawer"
  >
    <div slot="header" class="u-flex">
      <span class="headtitle">质量位详情</span>
      <div class="workimgadd" style="margin-top: 0; margin-left: 20px">
        <img src="@/assets/images/add.png" style="width: 12px; height: 12px" />
        <div class="addinput pot" @click="addqualitys">新增</div>
      </div>
    </div>
    <div class="dwermodel">
      <!-- <div @click="imgadda" class="pointaddfont">新增</div> -->
      <!--  -->
      <div
        class="u-flex"
        style="margin-bottom: 10px; width: 452px"
        v-for="(index, key) in qualitys"
        :key="key"
      >
        <div class="left">{{ index.sum }}</div>
        <div style="width: 100%">
          <Input
            maxlength="50"
            v-model="index.text"
            placeholder="最多支持50个中文字符"
          />
        </div>
        <div  class="prit-right" v-if="qualitys.length > 1 && key == len">
          <Tooltip trigger="hover" content="删除" theme="light">
            <div v-if="key == len" class="remmove" @click="itemsplice(key)">
              <img style="width: 24px" src="@/assets/images/remove.png" />
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
    <div class="drawer-footer" slot="footer">
      <Button type="primary" @click="submitForm('formValidate')">提交</Button>
      <Button style="margin-right: 8px" @click="closeDrawer">取消</Button>
    </div>
  </Modal>
</template>
  <script>
export default {
  props: {
    value: {},
    formData: [],
  },
  watch: {
    value(value) {
      if (value) {
        const { qualitys } = this.formData;

        if (qualitys == null || qualitys.length == 0) {
          this.addqualitys();
        } else {
          this.itemfroate(qualitys);
        }
        // this.list = JSON.parse(JSON.stringify(this.clist));
      }
    },
  },
  computed: {
    len() {
      return this.qualitys.length - 1;
    },
  },

  data() {
    return {
      qualitys: [],

      text: "",
    };
  },
  methods: {
    itemfroate(obj) {
      let arr = [];
      for (const key in obj) {
        arr.push({
          text: obj[key],
          sum: key,
        });
      }

      this.qualitys = arr;
    },
    itemsplice(idx) {
      let len = this.qualitys.length;
      if (len == 1) {
        this.$Message.info("最少保留一个");
      } else {
        this.qualitys.splice(idx, 1);
      }
    },
    addqualitys() {
      let sum = Math.pow(2, this.qualitys.length);
    
      this.qualitys.push({
        text: "",
        sum,
      });
      this.$forceUpdate();
    },
    submitForm() {
      let qualitys = this.qualitys;
      let obj = {};
      let bo = true;
      for (const key in qualitys) {
        let text = qualitys[key].text;
        if (text == "") {
          bo = false;
        }

        obj[qualitys[key].sum] = text;
      }
      if (bo) {
        this.$emit("change", obj);
        setTimeout(() => {
          this.closeDrawer();
        }, 100);
      } else {
        this.$Message.info("质量位数据不能为空");
      }
    },
    allselect(index) {
      this.list = this.list.map((e) => {
        e.bo = index;
        return e;
      });
    },
    closeDrawer() {
      this.qualitys = [];
      this.$emit("input", false);
    },
  },
};
</script>
  <style scoped lang="less">
.headtitle {
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  color: #17233d;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.workimgadd {
  display: flex;
  font-size: 12px;

  font-weight: 400;
  color: #0070cc;
  line-height: 8px;
  margin-top: 21px;
  align-items: center;

  div {
    margin-left: 3px;
  }
}
</style> 

  <style>
.mfdmodel .dw-item {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
}

.mfdmodel .drawer-footer {
  position: relative;
}

.mfdmodel .footer-left {
  position: absolute;
  left: 5px;
  font-size: 14px;
}
</style>
  <style lang="less" scoped>
.dwermodel {
  max-height: 320px;
  overflow: auto;
}
.mfdmodel {
}
.left {
  margin-right: 5px;
  height: 32px;
  // flex-basis:50px ;
  flex: 0 0 auto;
  width: 50px;
  font-size: 14px;
  border: 1px solid #dcdee2;
  padding: 4px 7px;
}
.prit-right{
   flex: 0 0 auto; /* 固定大小 */
   width: 24px;
}

.pointaddfont {
  color: #0070cc;
  cursor: pointer;
}
</style>